import { AutoPayUnEnrollRequest } from '@aaa-ncnu-ie/mypolicy-api-billing';

import axios from '../axios';

export interface UnenrollInAutoPayArgs {
  policy: AutoPayUnEnrollRequest;
}

export const unenrollInAutoPay = async ({ policy }: UnenrollInAutoPayArgs) => {
  const requestBody: AutoPayUnEnrollRequest = {
    ...policy,
  };
  const response = await axios.delete<void>(
    `${
      import.meta.env.VITE_MYPOLICY_BILLING_API_URL
    }/v1/payment/autopay/enrollment`,
    {
      data: requestBody,
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  return response;
};
